import type { AssetTypeDeleteButtonProps } from "./asset-type-delete-button.type";

import { useTranslation } from "react-i18next";

export const useAssetTypeDeleteButton = ({
  assetType,
}: AssetTypeDeleteButtonProps) => {
  const { t } = useTranslation();

  const isDeletable = assetType.is_deletable;
  const tooltip = !isDeletable ? t("assetType:deleteTooltipAssets") : undefined;

  return {
    isDeletable,
    tooltip,
  };
};
